import { Component, ElementRef, viewChild } from '@angular/core';

@Component({
  selector: 'app-how-to-buy',
  templateUrl: './how-to-buy.component.html',
  styleUrl: './how-to-buy.component.scss',
  standalone: false,
})
export class HowToBuyComponent {
  readonly slider = viewChild.required<ElementRef>('slider');

  boxes = [
    {
      title: 'how-to-buy.title1',
      desc: 'how-to-buy.desc1',
    },
    {
      title: 'how-to-buy.title2',
      desc: 'how-to-buy.desc2',
    },
    {
      title: 'how-to-buy.title3',
      desc: 'how-to-buy.desc3',
    },
    {
      title: 'how-to-buy.title4',
      desc: 'how-to-buy.desc4',
    },
  ];

  scrollLeft() {
    this.slider().nativeElement.scrollBy({ left: -300, behavior: 'smooth' });
  }

  scrollRight() {
    this.slider().nativeElement.scrollBy({ left: 300, behavior: 'smooth' });
  }
}
